"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withPageMeta = exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _gandi = require("gandi.react-helpers");
var _translate = require("@gandi/translate");
var _pageMeta = require("./pageMeta");
var _usePageMeta = require("./hooks/usePageMeta");
var _excluded = ["setPageMeta"],
  _excluded2 = ["withPageMetaTranslatorProps"],
  _excluded3 = ["translator"];
var withPageMeta = function withPageMeta(metaFunc) {
  return function (WrappedComponent) {
    function WithPageMeta(props) {
      var dispatch = (0, _reactRedux.useDispatch)();

      // Keep both extracts, different purposes
      var _ = props.setPageMeta,
        ownProps = (0, _objectWithoutProperties2.default)(props, _excluded);
      var withPageMetaTranslatorProps = props.withPageMetaTranslatorProps,
        restProps = (0, _objectWithoutProperties2.default)(props, _excluded2);
      // $FlowIgnore[cannot-spread-inexact]
      var args = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, withPageMetaTranslatorProps), restProps), {}, {
        dispatch: dispatch
      });
      var pageMeta = metaFunc(args);
      (0, _usePageMeta.usePageMeta)(pageMeta);
      return /*#__PURE__*/React.createElement(WrappedComponent, ownProps);
    }

    // HandlePageMeta will be decorated bywithTranslator
    WithPageMeta.handlePageMeta = function (_ref) {
      var translator = _ref.translator,
        args = (0, _objectWithoutProperties2.default)(_ref, _excluded3);
      var translatorProps = (0, _translate.createTranslatorProps)(translator);
      return metaFunc((0, _objectSpread2.default)((0, _objectSpread2.default)({}, args), translatorProps));
    };
    var ComposedWithPageMeta = (0, _translate.withTranslator)({
      propsNamespace: 'withPageMetaTranslatorProps'
    })(WithPageMeta);
    var HoistedComponent = (0, _hoistNonReactStatics.default)(ComposedWithPageMeta, WrappedComponent);
    // $FlowFixMe[incompatible-use] WrappedComponent property is not defined in withTranslator
    HoistedComponent.WrappedComponent = WrappedComponent;
    HoistedComponent.displayName = "WithPageMeta(".concat((0, _gandi.getDisplayName)(WrappedComponent), ")");
    return HoistedComponent;
  };
};
exports.withPageMeta = withPageMeta;
var _default = withPageMeta;
exports.default = _default;